import { selectFailedFiles, selectStoppedFiles, selectSuccessfulFiles, reset, retry, useAppDispatch } from "../../../../store";
import { useSelector } from "react-redux";
import { IconHeartFilled, IconRefreshAlert, IconPhotoPlus } from "@tabler/icons-react";
import { Button, Message } from "../../../components";
import { useTranslation } from "react-i18next";
import { useSite } from "../../../../store/useSite";
import "./Confirmation.scss";

export const Confirmation = () => {
  const { t } = useTranslation();
  const { resolvedDisplayName } = useSite();
  const dispatch = useAppDispatch();

  const failed = useSelector(selectFailedFiles).length;
  const success = useSelector(selectSuccessfulFiles).length;
  const stopped = useSelector(selectStoppedFiles).length;

  return (
    <div className="confirmation">
      <div className="icon">
        <IconHeartFilled size={200} />
        <h1>{t("upload.confirmation.thanks")}</h1>
      </div>
      <div>
        <h3>{t("upload.confirmation.subtitle")}</h3>
      </div>
      <div className="messages">
        {success > 0 && (
          <Message variant="success">
            {t("upload.confirmation.successCount", { count: success })}
          </Message>
        )}
        {failed > 0 && (
          <Message variant="error">
            {t("upload.confirmation.failCount", { count: failed })}
          </Message>
        )}
        {stopped > 0 && (
          <Message variant="warning">
            {t("upload.confirmation.cancelCount", { count: stopped })}
          </Message>
        )}
      </div>
      <div className="actions">
        {failed > 0 || stopped > 0 ? (
          <Button icon={<IconRefreshAlert />} onClick={() => dispatch(retry())}>
            {t("upload.confirmation.checkFailedBtn")}
          </Button>
        ) : (
          <Button
            variant="secondary"
            appearance="muted"
            icon={<IconPhotoPlus />}
            onClick={() => dispatch(reset())}
          >
            {t("upload.confirmation.uploadMoreBtn")}
          </Button>
        )}
      </div>
      <h1>{resolvedDisplayName}</h1>
    </div>
  )
}
